import { render, staticRenderFns } from "./login-main-email.vue?vue&type=template&id=01b05ac2&scoped=true";
import script from "./login-main-email.vue?vue&type=script&lang=js";
export * from "./login-main-email.vue?vue&type=script&lang=js";
import style0 from "./login-main-email.vue?vue&type=style&index=0&id=01b05ac2&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "01b05ac2", null);
export default component.exports;